// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imgbox[data-v-45b128b4]{width:80%;margin:0 auto 2.667vw}h1[data-v-45b128b4]{font-size:4.533vw;text-align:center;margin:5.333vw 0}.centerbox[data-v-45b128b4]{padding:0 5.333vw}.centerbox .p[data-v-45b128b4]{line-height:6.4vw;font-size:4vw;margin-bottom:5.333vw}", ""]);
// Exports
module.exports = exports;
